import { types } from 'mobx-state-tree'

export const Athlete = types
  .model('AthleteModel', {
    id: types.identifierNumber,
    name: types.string,
    surname: types.string,
    nationality: types.maybeNull(types.string),
    logo: types.maybeNull(types.string),
    sport: types.maybeNull(types.string),
    personalWebsite: types.maybeNull(types.string),
    dateOfBirth: types.maybeNull(types.Date),
  })
  .preProcessSnapshot((snapshot) => {
    // TODO: remove unicode dash in favour of ascii after DB cleanup
    if (!snapshot.dateOfBirth) {
      return snapshot
    }

    const [year, month, date] = snapshot.dateOfBirth.split(/\-|\u2013|\//)

    return {
      ...snapshot,
      dateOfBirth: new Date(year, month - 1, date),
    }
  })
  .views((self) => ({
    get fullName() {
      return `${self.name} ${self.surname}`
    },
  }))
